import {
  isDesktop,
  isMobile,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
  browserName,
} from 'react-device-detect';

const releaseVersion = process.env.REACT_APP_RELEASE_VERSION;

export function getAppVersion() {
  return releaseVersion;
}

export function getDeviceType() {
  return isDesktop ? 'desktop' : 'mobile';
}

export function getDeviceOS() {
  return `${osName} ${osVersion}`;
}

export function getDeviceModel() {
  // cant really tell device model in desktop devices based on the user agent
  return isMobile ? `${mobileVendor} ${mobileModel}` : 'unknown';
}

export function getSiblyClientHeader(): string {
  const appVersion = getAppVersion();
  const deviceType = getDeviceType();
  const deviceOS = getDeviceOS();
  const deviceModel = getDeviceModel();

  return `appVersion: ${appVersion}; clientType: browser; clientSubType: ${browserName}; deviceType: ${deviceType}; deviceOS: ${deviceOS}; deviceModel: ${deviceModel}; isEmulator: false;`;
}
